export class ValueRangeFilterSetting {
  step?: number;
  gridSnap?: boolean;

  // Default values
  constructor() {
    this.step = 1;
    this.gridSnap = true;
  }

  public static MockOne(step = 1, gridSnap = true) {
    return { step, gridSnap } as ValueRangeFilterSetting;
  }
}
